import { Component, OnInit } from '@angular/core';
import { TransferHttpService } from 'src/app/services/transfer-http/transfer-http.service';
import { PermissionsService } from 'src/app/services/permissions/permissions.service';
import { map } from 'rxjs/operators';
import { AimsCommonTableHeader, AimsCommonTablePermissions } from '@aims/common-components';

@Component({
  selector: 'app-oa-projects',
  templateUrl: './oa-projects.component.html',
  styleUrls: ['./oa-projects.component.scss']
})
export class OaProjectsComponent implements OnInit {

 // AimsCommonTable setup
  tableHeader: AimsCommonTableHeader[] = [
    { key: 'details', label: 'Details', type: 'button', prefix: '/projectSupport/oa/', linkId: 'oaNumber', filter: false },
    { key: 'noticeToProceedDate', label: 'NTP Date', type: 'date' },
    { key: 'oaNumber', label: 'OA Number', type: 'string' },
    { key: 'projectDescription', label: 'Project Description', type: 'string' },
    { key: 'sites', label: 'Sites', type: 'string' },
    { key: 'proposalPrice', label: 'Proposal $', type: 'dynamic' },
    { key: 'approvedPrice', label: 'Approved $', type: 'dynamic' },
    { key: 'overHead', label: 'Overhead', type: 'dynamic' },
    { key: 'purchases', label: 'Purchases', type: 'dynamic' },
    { key: 'labor', label: 'Labor', type: 'dynamic' },
    { key: 'travel', label: 'Travel', type: 'dynamic' },
    { key: 'totalCosts', label: 'Total Costs', type: 'dynamic' },
    { key: 'profitDollars', label: 'Profit $', type: 'dynamic' },
    { key: 'profitPercent', label: 'Profit %', type: 'dynamic' },
  ];

  tablePermissions: AimsCommonTablePermissions = {
    create: false,
    update: false,
    delete: false
  };
  constructor(private transferHttp: TransferHttpService,
    public permissions: PermissionsService) { }

    oaProjectName = this.transferHttp.tenantConfig.projectSupport.oaProjectName;

  oas = this.transferHttp.getSingle('ProjectSupport/GetOASummaries').pipe(
    map(oaArr => oaArr.sort((a, b) => a.noticeToProceedDate > b.noticeToProceedDate ? 1 : -1).sort((a,b) => a.oanumber > b.oanumber ? 1 : -1))
  );

  ngOnInit() {
  }

}
